window['APP_CONFIG'] = {
  QIWI_COM: '/',
  EDGE_URL: 'https://ao-edge.qplus.ru',
  ZEA_EDGE_URL: 'https://zea-edge.qplus.ru',
  JSON_URL: '/qcms/',
  ROOT_JSON: 'qhelp/qiwi_help/categories_1.json',
  BASE_NAME: '/support',
  RECAPTCHA_KEY: '6LeBGLsUAAAAABXuVszs2EoktfidefDEpDx_gnqb',
  QCHAT: {
    productUid: 'cb3d7920-7ef1-4023-9f2e-b9121e459ca7',
    websocketUrl: 'wss://ao-qw-websocket-edge.qiwi.com/ao-cis-kz-chat-cm/api/v1/ws',
    apiUrl: '/ao-cis-kz-chat-backend',
    baseUrl: 'https://ao-edge.qplus.ru',
    websocketAuthUrl: (personId) => `/qw-websocket-auth/v1/persons/${personId}/ws-tokens`
  }
};



//////////////////
// WEBPACK FOOTER
// ./neutrino-sp/config.prod.js
// module id = ./neutrino-sp/config.prod.js
// module chunks = prod